module.exports = "/_next/static/images/personal_recommendations-c9a22c1e9569316dbd2f0e6c1215e411.svg";